import { useContext, createElement, createContext } from 'react';
import { invariant } from 'ts-invariant';
import { init } from '@amplitude/node';
export { DefaultIdentity, identityManager } from '@amplitude/identity';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var _jsxFileName = "/home/runner/work/plugin-tracker/plugin-tracker/src/components/tracker-provider.tsx",
    _this = undefined;
let trackerContext;
function getTrackerContext() {
  if (!trackerContext) {
    trackerContext = createContext({});
  }

  return trackerContext;
} // Create use hook for consuming the default Tracker context

function useTracker() {
  const {
    instance
  } = useContext(getTrackerContext());
  invariant(instance, 'No Tracker Client instance can be found. Please ensure that you ' + 'have called `TrackerProvider` higher up in your tree.');
  return instance;
}
// Create context provider component for the Tracker context
const TrackerProvider = _ref => {
  let {
    children,
    instance
  } = _ref;
  const TrackerContext = getTrackerContext();
  return /*#__PURE__*/createElement(TrackerContext.Consumer, {
    __self: undefined,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 5
    }
  }, function () {
    let context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (instance && context.instance !== instance) {
      // eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
      context = _objectSpread2(_objectSpread2({}, context), {}, {
        instance
      });
    }

    invariant(context.instance, 'TrackerProvider was not passed an application instance.');
    return /*#__PURE__*/createElement(TrackerContext.Provider, {
      value: context,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 57,
        columnNumber: 16
      }
    }, children);
  });
};

var _jsxFileName$1 = "/home/runner/work/plugin-tracker/plugin-tracker/src/components/api-tracker-provider.tsx",
    _this$1 = undefined;
let apiTrackerContext;
function getAPITrackerContext() {
  if (!apiTrackerContext) {
    apiTrackerContext = createContext({});
  }

  return apiTrackerContext;
} // Create use hook for consuming the default APITracker context

function useAPITracker() {
  const {
    instance
  } = useContext(getAPITrackerContext());
  invariant(instance, 'No APITracker APIClient instance can be found. Please ensure that you ' + 'have called `APITrackerProvider` higher up in your tree.');
  return instance;
}
// Create context provider component for the APITracker context
const APITrackerProvider = _ref => {
  let {
    children,
    instance
  } = _ref;
  const APITrackerContext = getAPITrackerContext();
  return /*#__PURE__*/createElement(APITrackerContext.Consumer, {
    __self: undefined,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 48,
      columnNumber: 5
    }
  }, function () {
    let context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (instance && context.instance !== instance) {
      // eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
      context = _objectSpread2(_objectSpread2({}, context), {}, {
        instance
      });
    }

    invariant(context.instance, 'APITrackerProvider was not passed an application instance.');
    return /*#__PURE__*/createElement(APITrackerContext.Provider, {
      value: context,
      __self: _this$1,
      __source: {
        fileName: _jsxFileName$1,
        lineNumber: 57,
        columnNumber: 16
      }
    }, children);
  });
};

/**
 * Copyright 2022 Design Barn Inc.
 */
const mutation = {
  createHitCountEvent: `
    mutation createHitCountEvent(
      $source: Float
      $userId: Float
      $visitorId: Float
      $resourceId: Float!
      $method: Float!
    ) {
      createHitCountEvent(
        source: $source
        userId: $userId
        visitorId: $visitorId
        resourceId: $resourceId
        method: $method
      ) {
        status
        message
      }
    }
  `
};

/**
 * Copyright 2021 Design Barn Inc.
 */
const eventsConst = {
  click: {
    tab: 'click tab',
    logout: 'logout',
    animation: 'click animation',
    insertAnimation: 'insert animation',
    login: 'login',
    signup: 'signUp',
    saveAni: 'save animation',
    redirectAni: 'redirect animation',
    viewOnMob: 'view on mobile',
    settings: 'view settings',
    compSettings: 'click composition settings',
    publish: 'publish to web',
    session: 'session start',
    pageView: 'pageView'
  },
  keyed: {
    search: 'explore keywords'
  },
  import: 'import local file',
  pageView: 'pageView'
};
const api = {
  graphql: 'https://graphql.lottiefiles.com',
  amplitudeAPIDomain: 'https://api2.amplitude.com/2/httpapi'
};

/**
 * Copyright 2022 Design Barn Inc.
 */
const gqlFetch = async (query, hcToken, variables) => {
  const data = await fetch(api.graphql, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: hcToken ? `Bearer ${hcToken}` : null
    },
    body: JSON.stringify({
      query,
      variables
    })
  });
  return data.json();
};
const tracker = async (trackerApiKey, events) => {
  return fetch(api.amplitudeAPIDomain, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: '*/*'
    },
    body: JSON.stringify({
      api_key: trackerApiKey,
      events
    })
  });
};

let properties;
let notTracking;
let hcToken;
class APIClient {
  static getInstance(apiKey, time, platform, appVersion, deviceId, sourceId, token, _notTracking) {
    if (!APIClient.instance) {
      const instance = new APIClient();
      APIClient.instance = instance;
    }

    properties = {
      time,
      platform,
      appVersion,
      deviceId,
      sourceId,
      apiKey
    };
    notTracking = _notTracking ? _notTracking : false;
    hcToken = token;
    return APIClient.instance;
  }

  pluginTracking(options) {
    try {
      if (!notTracking && properties.apiKey) {
        tracker(properties.apiKey, [{
          event_type: options.eventType,
          user_id: options.userId && options.userId.toString(),
          location_lat: options.locationLat && options.locationLat,
          location_lng: options.locationLng && options.locationLng,
          version_name: options.versionName && options.versionName,
          library: options.library && options.library,
          os_name: options.osName && options.osName,
          os_version: options.osVersion && options.osVersion,
          device_brand: options.deviceBrand && options.deviceBrand,
          device_manufacturer: options.deviceManufacturer && options.deviceManufacturer,
          device_model: options.deviceModel && options.deviceModel,
          carrier: options.carrier && options.carrier,
          country: options.country && options.country,
          region: options.region && options.region,
          city: options.city && options.city,
          dma: options.dma && options.dma,
          idfa: options.idfa && options.idfa,
          idfv: options.idfv && options.idfv,
          adid: options.adid && options.adid,
          android_id: options.androidId && options.androidId,
          language: options.language && options.language,
          ip: options.ip && options.ip,
          uuid: options.uuid && options.uuid,
          event_properties: options.eventProperties && options.eventProperties,
          user_properties: options.userProperties && options.userProperties,
          price: options.price && options.price,
          quantity: options.quantity && options.quantity,
          revenue: options.revenue && options.revenue,
          productId: options.productId && options.productId,
          revenueType: options.revenueType && options.revenueType,
          event_id: options.eventId && options.eventId,
          session_id: options.sessionId && options.sessionId,
          insert_id: options.insertId && options.insertId,
          groups: options.groups && options.groups,
          time: properties.time ? properties.time : options.time && options.time,
          platform: properties.platform ? properties.platform : options.platform && options.platform,
          app_version: properties.appVersion ? properties.appVersion : options.appVersion && options.appVersion,
          device_id: properties.deviceId ? properties.deviceId : options.deviceId && options.deviceId
        }]);

        if (options.userId && options.method && properties.sourceId) {
          gqlFetch(mutation.createHitCountEvent, hcToken, {
            resourceId: options.resourceId ? options.resourceId : options.userId,
            // if no resouceId use userId
            method: options.method,
            source: properties.sourceId,
            userId: options.userId && options.userId,
            visitorId: options.visitorId && options.visitorId
          });
        }
      }
    } catch (err) {
      throw new Error(err);
    }
  }

}

_defineProperty(APIClient, "instance", void 0);

let client;
let properties$1;
let notTracking$1;
let hcToken$1;
class Client {
  static getInstance(apiKey, time, platform, appVersion, deviceId, sourceId, token, _notTracking) {
    if (!Client.instance) {
      const instance = new Client();
      Client.instance = instance;
    }

    properties$1 = {
      time,
      platform,
      appVersion,
      deviceId,
      sourceId
    };
    notTracking$1 = _notTracking ? _notTracking : false;
    hcToken$1 = token;
    if (notTracking$1) client = init(apiKey);
    return Client.instance;
  }

  async pluginTracking(options) {
    try {
      if (notTracking$1) {
        client.logEvent({
          event_type: options.eventType,
          user_id: options.userId && options.userId.toString(),
          location_lat: options.locationLat && options.locationLat,
          location_lng: options.locationLng && options.locationLng,
          version_name: options.versionName && options.versionName,
          library: options.library && options.library,
          os_name: options.osName && options.osName,
          os_version: options.osVersion && options.osVersion,
          device_brand: options.deviceBrand && options.deviceBrand,
          device_manufacturer: options.deviceManufacturer && options.deviceManufacturer,
          device_model: options.deviceModel && options.deviceModel,
          carrier: options.carrier && options.carrier,
          country: options.country && options.country,
          region: options.region && options.region,
          city: options.city && options.city,
          dma: options.dma && options.dma,
          idfa: options.idfa && options.idfa,
          idfv: options.idfv && options.idfv,
          adid: options.adid && options.adid,
          android_id: options.androidId && options.androidId,
          language: options.language && options.language,
          ip: options.ip && options.ip,
          uuid: options.uuid && options.uuid,
          event_properties: options.eventProperties && options.eventProperties,
          user_properties: options.userProperties && options.userProperties,
          price: options.price && options.price,
          quantity: options.quantity && options.quantity,
          revenue: options.revenue && options.revenue,
          productId: options.productId && options.productId,
          revenueType: options.revenueType && options.revenueType,
          event_id: options.eventId && options.eventId,
          session_id: options.sessionId && options.sessionId,
          insert_id: options.insertId && options.insertId,
          groups: options.groups && options.groups,
          time: properties$1.time ? properties$1.time : options.time && options.time,
          platform: properties$1.platform ? properties$1.platform : options.platform && options.platform,
          app_version: properties$1.appVersion ? properties$1.appVersion : options.appVersion && options.appVersion,
          device_id: properties$1.deviceId ? properties$1.deviceId : options.deviceId && options.deviceId
        });
        client.flush();

        if (options.userId && options.method && properties$1.sourceId) {
          gqlFetch(mutation.createHitCountEvent, hcToken$1, {
            resourceId: options.resourceId ? options.resourceId : options.userId,
            // if no resouceId use userId
            method: options.method,
            source: properties$1.sourceId,
            userId: options.userId && options.userId,
            visitorId: options.visitorId && options.visitorId
          });
        }
      }
    } catch (err) {
      throw new Error(err);
    }
  }

}

_defineProperty(Client, "instance", void 0);

/**
 * Copyright 2020 Design Barn Inc.
 */

const createTrackerBridge = (apiKey, time, platform, appVersion, deviceId, sourceId, token, notTracking // eslint-disable-next-line no-return-await
) => Client.getInstance(apiKey, time, platform, appVersion, deviceId, sourceId, token, notTracking); // eslint-disable-next-line no-return-await

const createAPITrackerBridge = (apiKey, time, platform, appVersion, deviceId, sourceId, token, notTracking // eslint-disable-next-line no-return-await
) => APIClient.getInstance(apiKey, time, platform, appVersion, deviceId, sourceId, token, notTracking);

/**
 * Copyright 2022 Design Barn Inc.
 */
var tabsType;

(function (tabsType) {
  tabsType["compositions"] = "Compositions";
  tabsType["discover"] = "Discover";
  tabsType["import"] = "Import";
  tabsType["myAnimation"] = "My Animation";
  tabsType["myLotties"] = "My Lotties";
  tabsType["search"] = "Search";
})(tabsType || (tabsType = {}));

var animationsType;

(function (animationsType) {
  animationsType["gif"] = "GIF";
  animationsType["lottie"] = "Lottie";
  animationsType["png"] = "PNG";
  animationsType["svg"] = "SVG";
})(animationsType || (animationsType = {}));

var loginIntentType;

(function (loginIntentType) {
  loginIntentType["clicked"] = "clicked";
  loginIntentType["completed"] = "completed";
})(loginIntentType || (loginIntentType = {}));

var importType;

(function (importType) {
  importType["dlottie"] = "dotLottie";
  importType["json"] = "JSON";
})(importType || (importType = {}));

var settingsType;

(function (settingsType) {
  settingsType["about"] = "about plugin";
  settingsType["feedback"] = "feedback";
  settingsType["helpC"] = "help centre";
  settingsType["profiles"] = "profles";
})(settingsType || (settingsType = {}));

var animationListClickType;

(function (animationListClickType) {
  animationListClickType["composition"] = "Composition";
  animationListClickType["explore"] = "Explore";
  animationListClickType["featured"] = "Featured";
  animationListClickType["preview"] = "Preview";
})(animationListClickType || (animationListClickType = {}));

const eventEnums = {
  tabsType,
  animationsType,
  animationListClickType,
  loginIntentType,
  importType,
  settingsType
};

export { APIClient, APITrackerProvider, Client, TrackerProvider, createAPITrackerBridge, createTrackerBridge, eventEnums, eventsConst, useAPITracker, useTracker };
//# sourceMappingURL=index.es.js.map
